module.exports = __webpack_public_path__ + "media/configurations/ZOC_O-X-X-4ffec03a.png";